import { useMutation } from '@tanstack/react-query';
import { backendServices } from '../../services';
import { ValidateAccountRequestViewModel } from '../../services/backendServices/ViewModels';

/** POST /DocumentType/ValidateAccount — verify ACH account/routing via Plaid. */
export function useValidateAccount(params: {
    SupplierCompanyId: number | null;
    VendorId: number | null;
    BuyerCompanyId: number | null;
}) {
    const mutation = useMutation({
        mutationFn: async (body: ValidateAccountRequestViewModel) => {
            const api = new backendServices.Apis.DocumentTypeApi();
            const res = await api.validateAccount({
                ...body,
                VendorId: params.VendorId ?? undefined,
                SupplierCompanyId: params.SupplierCompanyId ?? undefined,
                BuyerCompanyId: params.BuyerCompanyId ?? undefined,
            });
            return res.data;
        },
    });

    return mutation;
}
